module.exports = __webpack_public_path__ + "static/media/2 (17).6c35353d.jpg";